<mat-card class="app-link-icon" (click)="cardClicked(icon)">
    <div class="header">
        <mat-card-header>
            <mat-card-title>{{ icon.name }}</mat-card-title>
        </mat-card-header>

        <img class="image" mat-card-image *ngIf="icon.icon" [src]="icon.icon" alt="{{ icon.name }}">
    </div>
</mat-card>
